import React from 'react';

import { DollarInputFormatter } from '@x1/util-format';

import HousingExpenseModal from './HousingExpenseModal';
import IconButton from 'src/components/creditApplication/IconButton';
import TextInput from 'src/components/creditApplication/TextInput';

interface PropsIface {
  value: string;
  onChange: (value: string) => void;
}

const HousingExpenseInput = ({ value, onChange }: PropsIface) => {
  const [showHousingExpenseDialog, setShowHousingExpenseDialog] = React.useState<boolean>(false);

  const _onChange = React.useCallback(
    ({ value }: { value: string }) => {
      const formatted = DollarInputFormatter.serialize(value);
      onChange(formatted);
    },
    [onChange],
  );

  const onShowHousingExpenseDialog = React.useCallback(() => {
    setShowHousingExpenseDialog(true);
  }, []);

  const onDismissHousingExpenseDialog = React.useCallback(() => {
    setShowHousingExpenseDialog(false);
  }, []);

  return (
    <>
      <TextInput
        placeholder='Monthly housing expense'
        value={value}
        onChange={_onChange}
        inputMode='numeric'
        endControl={
          // TODO (szhang): Figure out why HoverState has different base background color
          <IconButton
            type='button'
            icon='Info16'
            onClick={onShowHousingExpenseDialog}
            aria-label='Show housing expense details'
          />
        }
      />
      {showHousingExpenseDialog && <HousingExpenseModal onDismiss={onDismissHousingExpenseDialog} />}
    </>
  );
};

export default HousingExpenseInput;
